<script>
import Mobile from "./Mobile";
import Desktop from "./Desktop";

export default {
  title: "Histórico de Pedidos",
  components: {
    Mobile,
    Desktop
  },
  data() {
    return {
      width: 0,
      height: 0
    };
  },
  methods: {
    handleResize() {
      this.width = window.innerWidth;
      this.height = window.innerHeight;
    }
  },
  created() {
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
  },
  destroyed() {
    window.removeEventListener("resize", this.handleResize);
  }
};
</script>

<template>
  <div class="container">
    <mobile v-if="width <= 992" />
    <desktop v-else />
  </div>
</template>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/OrderHistory/Index.vue